<template>
  <div class="car-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('carDetail.page.title')" :subtitle="$t('carDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="$router.go(-1)">
          {{ $t('common.back') }}
        </el-button>
        <el-button
          v-if="hasPrivilege('502023032804261679')"
          type="primary"
          icon="el-icon-edit"
          @click="_openEditDetailOwnerCar()"
        >
          {{ $t('common.edit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 车辆信息面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('carDetail.vehicleInfo') }}</span>
        <ds-status-tag :label="carDetailInfo.stateName || '-'" :text="carDetailInfo.stateName" type="info" />
      </div>
      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.licensePlate') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.carNum || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.carBrand') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.carBrand || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.carType') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.leaseTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.color') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.carColor || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.licenseType') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.carTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.leaseStart') }}</span>
          <span class="ds-info-grid__value ds-num">{{ carDetailInfo.startTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.leaseEnd') }}</span>
          <span class="ds-info-grid__value ds-num">{{ carDetailInfo.endTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.remark') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.remark || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.parkingLot') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.areaNum || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.parkingSpace') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.num || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.status') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag :label="carDetailInfo.stateName || '-'" :text="carDetailInfo.stateName" type="info" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('carDetail.relatedHouse') }}</span>
          <span class="ds-info-grid__value">{{ carDetailInfo.roomName || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- (3) 业务标签页面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="carDetailInfo._currentTab" @tab-click="changeTab(carDetailInfo._currentTab)">
        <el-tab-pane :label="$t('carDetail.vehicleFee')" name="carDetailFee" />
        <el-tab-pane :label="$t('carDetail.paymentRecord')" name="ownerDetailHisFee" />
        <el-tab-pane :label="$t('carDetail.modificationRecord')" name="carDetailHis" />
        <el-tab-pane :label="$t('carDetail.memberVehicle')" name="carDetailMember" />
        <el-tab-pane :label="$t('carDetail.ownerInfo')" name="carDetailOwner" />
        <el-tab-pane :label="$t('carDetail.ownerHouse')" name="ownerDetailRoom" />
        <el-tab-pane :label="$t('carDetail.ownerVehicle')" name="ownerDetailCar" />
        <el-tab-pane :label="$t('carDetail.ownerArrears')" name="ownerDetailOweFee" />
        <el-tab-pane :label="$t('carDetail.licenseSync')" name="carDetailTransactionCar" />
        <el-tab-pane :label="$t('carDetail.parkingApplication')" name="carDetailApplyParkingSpace" />
        <el-tab-pane :label="$t('carDetail.accessRecord')" name="carDetailCarInout" />
        <el-tab-pane :label="$t('carDetail.coupon')" name="carDetailCoupon" />
        <el-tab-pane :label="$t('carDetail.couponVerification')" name="carDetailCouponOrder" />
      </el-tabs>
    </div>

    <div class="ds-panel ds-panel--padded ds-panel--tab-content">
      <car-detail-fee v-if="carDetailInfo._currentTab === 'carDetailFee'" ref="carDetailFee" />
      <owner-detail-room
        v-if="carDetailInfo._currentTab === 'ownerDetailRoom'"
        ref="ownerDetailRoom"
      />
      <owner-detail-car v-if="carDetailInfo._currentTab === 'ownerDetailCar'" ref="ownerDetailCar" />
      <owner-detail-owe-fee
        v-if="carDetailInfo._currentTab === 'ownerDetailOweFee'"
        ref="ownerDetailOweFee"
      />
      <owner-detail-his-fee
        v-if="carDetailInfo._currentTab === 'ownerDetailHisFee'"
        ref="ownerDetailHisFee"
      />
      <car-detail-his v-if="carDetailInfo._currentTab === 'carDetailHis'" ref="carDetailHis" />
      <car-detail-member
        v-if="carDetailInfo._currentTab === 'carDetailMember'"
        ref="carDetailMember"
      />
      <car-detail-owner v-if="carDetailInfo._currentTab === 'carDetailOwner'" ref="carDetailOwner" />
      <car-detail-transaction-car
        v-if="carDetailInfo._currentTab === 'carDetailTransactionCar'"
        ref="carDetailTransactionCar"
      />
      <car-detail-apply-parking-space
        v-if="carDetailInfo._currentTab === 'carDetailApplyParkingSpace'"
        ref="carDetailApplyParkingSpace"
      />
      <car-detail-car-inout
        v-if="carDetailInfo._currentTab === 'carDetailCarInout'"
        ref="carDetailCarInout"
      />
      <car-detail-coupon
        v-if="carDetailInfo._currentTab === 'carDetailCoupon'"
        ref="carDetailCoupon"
      />
      <car-detail-coupon-order
        v-if="carDetailInfo._currentTab === 'carDetailCouponOrder'"
        ref="carDetailCouponOrder"
      />
    </div>

    <edit-car ref="editCar" />
  </div>
</template>

<script>
import CarDetailFee from '@/components/car/carDetailFee'
import OwnerDetailRoom from '@/components/owner/ownerDetailRoom'
import OwnerDetailCar from '@/components/owner/ownerDetailCar'
import OwnerDetailOweFee from '@/components/car/ownerDetailOweFee'
import OwnerDetailHisFee from '@/components/owner/ownerDetailHisFee'
import CarDetailHis from '@/components/system/carDetailHis'
import CarDetailMember from '@/components/car/carDetailMember'
import CarDetailOwner from '@/components/fee/carDetailOwner'
import CarDetailTransactionCar from '@/components/car/carDetailTransactionCar'
import CarDetailApplyParkingSpace from '@/components/car/carDetailApplyParkingSpace'
import CarDetailCarInout from '@/components/car/carDetailCarInout'
import CarDetailCoupon from '@/components/car/carDetailCoupon'
import CarDetailCouponOrder from '@/components/car/carDetailCouponOrder'
import EditCar from '@/components/car/editCar'
import { getCommunityId } from '@/api/community/communityApi'
import { getOwnerCarDetail } from '@/api/car/carDetailApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'CarDetail',
  components: {
    CarDetailFee,
    OwnerDetailRoom,
    OwnerDetailCar,
    OwnerDetailOweFee,
    OwnerDetailHisFee,
    CarDetailHis,
    CarDetailMember,
    CarDetailOwner,
    CarDetailTransactionCar,
    CarDetailApplyParkingSpace,
    CarDetailCarInout,
    CarDetailCoupon,
    CarDetailCouponOrder,
    EditCar,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      carDetailInfo: {
        memberId: '',
        carId: '',
        carNum: '',
        carTypeCd: '',
        carTypeCdName: '',
        carType: '',
        carTypeName: '',
        startTime: '',
        endTime: '',
        leaseType: '',
        leaseTypeName: '',
        areaNum: '',
        num: '',
        remark: '',
        stateName: '',
        carColor: '',
        carBrand: '',
        ownerId: '',
        roomName: '',
        carNumType: '',
        paId: '',
        _currentTab: 'carDetailFee',
        needBack: false
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.carDetailInfo.memberId = this.$route.query.memberId
    let tab = this.$route.query.tab
    if (tab) {
      this.carDetailInfo._currentTab = tab
    }
    if (this.carDetailInfo.memberId) {
      this._loadCarDetailInfo()
    }
  },
  methods: {
    _loadCarDetailInfo() {
      const params = {
        page: 1,
        row: 1,
        memberId: this.carDetailInfo.memberId,
        communityId: this.communityId
      }

      getOwnerCarDetail(params)
        .then(response => {
          const carInfo = response.data[0]
          Object.assign(this.carDetailInfo, carInfo)
          this.changeTab(this.carDetailInfo._currentTab)
        })
        .catch(error => {
          console.error('Failed to load car detail:', error)
        })
    },
    changeTab(tab) {
      this.carDetailInfo._currentTab = tab
      const tabData = {
        memberId: this.carDetailInfo.memberId,
        carId: this.carDetailInfo.carId,
        ownerId: this.carDetailInfo.ownerId,
        carNum: this.carDetailInfo.carNum,
        paId: this.carDetailInfo.paId,
        areaNum: this.carDetailInfo.areaNum
      }
      setTimeout(() => {
        if (this.$refs[tab]) {
          if (tab === 'ownerDetailHisFee' || tab == 'ownerDetailRoom' || tab == 'ownerDetailCar') {
            this.$refs[tab].open(this.carDetailInfo.ownerId)
          } else {
            this.$refs[tab].open(tabData)
          }
        }
      }, 100)

    },
    _openEditDetailOwnerCar() {
      this.$refs.editCar.open(this.carDetailInfo)
    },
  }
}
</script>

<style lang="scss" scoped>
.car-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &--tabs {
    padding: 0 var(--ds-spacing-lg);
    margin-bottom: 0;
    border-radius: var(--ds-radius-md) var(--ds-radius-md) 0 0;
    border-bottom: none;
  }

  &--tab-content {
    border-radius: 0 0 var(--ds-radius-md) var(--ds-radius-md);
  }
}

.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 信息栅格 */
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);

  &__item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__label {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-md);
    color: var(--ds-gray-800);
    word-break: break-all;
  }
}
</style>
